// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3q2Ni","author":"Table_author__3RdLS","authorImage":"Table_authorImage__f_iN3","unreadRow":"Table_unreadRow__24hNc"};